export default {
  undo: 'campaign.undo_campaign_block',
};
